<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="6">
        <div class="text-center">
          <img src="img/waf_level.png"
            class="text-center"
            style="margin-left: auto; margin-right: auto; width: auto; height:230px;"
          >
        </div>
      </b-col>
      <b-col sm="6">
        <p :style="`${server.level >= 4 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 4 is detect by policy level 1 ~ 4 </p>
        <p :style="`${server.level >= 3 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 3 is detect by policy level 1 ~ 3 </p>
        <p :style="`${server.level >= 2 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 2 is detect by policy level 1 ~ 2 </p>
        <p :style="`${server.level >= 1 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 1 is detect by policy level 1 </p>
        <hr>
        <p>
          The higher the level, the deeper the attack is detected.
        </p>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col class="col-xl-12 col-md-12 align-self-center text-center">
        <p class="title">
          Setting by Default
        </p>
        <small>Click to change</small>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col class="col-xl-6 col-md-12 align-self-center">
        <b-row>
          <b-col class="col-xl-6 col-md-12 align-self-center text-center" style="cursor: pointer;">
            <strong @click="change">FireWall Mode :
              <b-badge style="cursor: pointer;" v-if="server.mode == 0" variant="secondary">Off</b-badge>
              <b-badge style="cursor: pointer;" v-if="server.mode == 1" variant="warning">Detect</b-badge>
              <b-badge style="cursor: pointer;" v-if="server.mode == 2" variant="danger">Block</b-badge>
            </strong>
              <!-- <b-form-radio-group id="ph_mode" v-model="server.mode" :options="codes.WAF_MODE"> </b-form-radio-group> -->
          </b-col>
          <b-col class="col-xl-6 col-md-12 d-flex align-self-center"></b-col>
          <b-col class="col-xl-6 col-md-12 align-self-center mt-5" style="cursor: pointer;">
            <strong>Policy Security Level<br>
              <small class="mt-1">( Level : {{ server.level }})</small>
            </strong>
          </b-col>
          <b-col class="col-xl-6 col-md-12 align-self-center text-center mt-4" style="cursor: pointer;">
            <b-form-radio-group @change="update($event, 'level')" id="ph_level" v-model="server.level" :options="codes.WAF_LEVEL"></b-form-radio-group>
          </b-col>
          <!-- <b-col md="3">
            <div class="pull-right">
              <b-button size="sm" variant="success" @click="rule_confirm = true">Apply</b-button>
              <b-button size="sm" variant="warning" @click="apply_modal = true">Apply to other servers</b-button>
            </div>
          </b-col> -->
        </b-row>
      </b-col>
      <b-col class="col-xl-6 col-md-12 align-self-center">
        <b-card>
          <b-row>
            <b-col class="col-xl-12 col-md-12 align-self-center">
              <p class="title text-center">
                Notice
              </p>
              <small>If you set the immediate level high, there may be service problems. Recommended setting firewall level 4 with long-term plan</small>
            </b-col>
            <b-col class="col-xl-12 col-md-12 align-self-center text-left mt-5">
              <strong class="mb-3"><b-badge variant="secondary">Off</b-badge> : Disable WEBCastle function for the currently selected domain</strong>
              <br><br>
              <strong><b-badge variant="warning">Detect</b-badge> : Detect Only while on Activation</strong>
              <br><br>
              <strong><b-badge variant="danger">On</b-badge> : Block While On Activation (Not recommended for initial setup)</strong>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
